<h2>Welcome case прогресс</h2>
<div class="container welcome-case-container">

  <div class="welcome-case-table-container">
    <div class="progress-bar" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-table [dataSource]="welcomeCaseDataSource" class="table welcome-case-table" matSort #welcomeCaseTable>

      <!-- count Column -->
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef> #</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"> {{i + 1}}</mat-cell>
      </ng-container>

      <!-- action Column -->
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>action</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.action}}</mat-cell>
      </ng-container>

      <!-- status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>status</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.status}}</mat-cell>
      </ng-container>

      <!-- progress Column -->
      <ng-container matColumnDef="progress">
        <mat-header-cell *matHeaderCellDef>progress</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.progress | json}}</mat-cell>
      </ng-container>

      <!-- caseSet Column -->
      <ng-container matColumnDef="caseSet">
        <mat-header-cell *matHeaderCellDef>caseSet</mat-header-cell>
        <mat-cell *matCellDef="let element">{{'set: ' + element.caseSet.id  + ' | ' + element.caseSet.case.name}}
        </mat-cell>
      </ng-container>

      <!-- data Column -->
      <ng-container matColumnDef="data">
        <mat-header-cell *matHeaderCellDef>data</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.data | json}}</mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="welcomeCaseColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: welcomeCaseColumns;"></mat-row>

      <div class="empty-data" *matNoDataRow>
        <p>Данные отсутствуют</p>
      </div>
    </mat-table>
    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]"></mat-paginator>
  </div>

</div>

